export const CalendarItemsEndpoint = {
  GET_DATA: '/default/calendar-items/get-data',
};
